import React, { useEffect, useState } from "react";
import axios from "axios";
import "./App.css";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Form, Segment, Button, Card, Image } from "semantic-ui-react";
import frequency from "./frequency";
import ranking from "./ranking";

const getThoth = async (n: number) => {
  const { data } = await axios.get(
    `https://domainofthoth.mypinata.cloud/ipfs/QmWwjHdfmfJToTRsFhNvoGE8kwHw54rii3UfdoevnTQDTX/${n}.json`
  );

  return data;
};

type TraitType = keyof typeof frequency;

function App() {
  const [id, setId] = useState<number>();
  const [thoth, setThoth] = useState<{
    name: string;
    image: string;
    attributes: {
      trait_type: TraitType;
      value: string;
    }[];
  }>();
  const [loading, setLoading] = useState(false);

  const [rarity, setRarity] = useState({
    Background: 1,
    Thoth: 1,
    Features: 1,
    Beak: 1,
    Eyes: 1,
    Books: 1,
    Pens: 1,
    Crosses: 1,
    Scarves: 1,
    Smoko: 1,
  });

  useEffect(() => {
    (async () => {
      if (id) {
        setLoading(true);
        setThoth(undefined);
        setThoth(await getThoth(id));
        setLoading(false);
      }
    })();
  }, [id]);

  useEffect(() => {}, [thoth]);

  const formik = useFormik({
    initialValues: {
      id: "",
    },
    validationSchema: Yup.object({
      id: Yup.number().min(1).max(800).integer().required("Required"),
    }),
    onSubmit: (values) => {
      if (!isNaN(+values.id)) {
        setId(parseInt(values.id));
      }
    },
  });

  return (
    <div>
      <div
        style={{
          width: "30%",
          margin: "auto",
        }}
      >
        <Segment>
          <div style={{ textAlign: "center" }}>
            {thoth && id ? (
              <div
                style={{
                  width: "70%",
                  textAlign: "center",
                  margin: "auto",
                  padding: "20px 0",
                }}
              >
                <Card fluid>
                  <Image src={thoth.image} wrapped ui={false} />
                  <Card.Content>
                    <Card.Header>{thoth.name}</Card.Header>
                    <Card.Meta>
                      <span>
                        Rank {ranking[id - 1].rank}/{ranking.length}
                      </span>
                    </Card.Meta>
                    <Card.Description>
                      {thoth.attributes.map((attr) => {
                        // @ts-ignore
                        const x = frequency[attr.trait_type][attr.value];
                        return (
                          <div
                            style={{
                              textAlign: "left",
                            }}
                          >
                            {attr.trait_type}:{" "}
                            <b>
                              {attr.value} (
                              {((x / ranking.length) * 100).toFixed(2)}
                              %)
                            </b>
                          </div>
                        );
                      })}
                    </Card.Description>
                  </Card.Content>
                </Card>
              </div>
            ) : null}
          </div>
          <Form onSubmit={formik.handleSubmit} loading={loading}>
            <Form.Input
              id="id"
              label="Thoth ID"
              placeholder="Thoth ID"
              required
              {...formik.getFieldProps("id")}
              {...(formik.touched.id && formik.errors.id
                ? {
                    error: {
                      content: formik.errors.id,
                      pointing: "below",
                    },
                  }
                : {})}
            />
            <Button type="submit" fluid primary>
              Check
            </Button>
          </Form>
        </Segment>
      </div>
    </div>
  );
}

export default App;
